import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {IconProp, LangService, LoaderService, NavigateService} from '@satoris/ngx-satoris';
import {ClaimSelfAlt, ClaimSelfDetails, ClaimType} from 'src/app/shared/models/claim';
import {ApiService} from 'src/app/shared/services/api.service';
import {PersonnalDatasService} from 'src/app/shared/services/personnal-datas.service';
import {isObjectEmpty} from 'src/app/shared/utils/verification';

@Component({
  selector: 'app-personnal-data',
  templateUrl: './personnal-data.component.html',
  styleUrls: ['./personnal-data.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PersonnalData implements OnInit{

  ClaimsTypes: (string | ClaimType | ClaimSelfAlt)[] = [];
  isObjectEmpty = isObjectEmpty;

  constructor(public api: ApiService,
    public nav: NavigateService,
    public loader: LoaderService,
    public lang: LangService,
    public personnalDatas: PersonnalDatasService) {
  }

  ngOnInit() {
    this.ClaimsTypes = Object.entries(this.personnalDatas.countryClaims)
      .filter(([_, value]) => value !== undefined)
      .map(([key]) => key);
  }

  back() {
    this.nav.to('user');
  }

  stateByClaimType(type: ClaimType & ClaimSelfAlt): { icon: IconProp, color: string } {
    const claimSelf: ClaimSelfDetails = this.personnalDatas?.selfClaims?.[type];
    let highestPriorityState: ClaimSelfDetails | null = null;
    if(claimSelf) {
      const hasClaimType = Object.keys(claimSelf).some((key: any) => ClaimType[key] !== undefined);
      if(hasClaimType) {
        for(const subClaim of Object.values(claimSelf)) {
          if(!highestPriorityState) {
            highestPriorityState = subClaim;
          } else {
            if(this.personnalDatas.isHigherPriority(subClaim, highestPriorityState)) {
              highestPriorityState = subClaim;
            }
          }
        }
      } else {
        highestPriorityState = claimSelf;
      }
    }
    return this.personnalDatas.stateVisual(highestPriorityState);
  }
}
